import { getRgObjectsOfType as s, RG_TYPE as c } from "@project-rouge/rg-core";
function u(l, n, f) {
  let o = 0;
  const i = s(l, c.Building);
  for (const t of i) {
    const r = new Set(t.data.levels.filter((e) => e.isRoof).map((e) => e.levelIndex));
    for (const e of r)
      o += n(t, e, f);
  }
  return o;
}
export {
  u as getMetricFromRoofLevels
};
//# sourceMappingURL=index7.js.map
